import { render, staticRenderFns } from "./RcEditor.vue?vue&type=template&id=4e6ee4f4&"
import script from "./RcEditor.vue?vue&type=script&lang=js&"
export * from "./RcEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports